import React, { Component } from 'react';
import { range } from 'lodash';
import { RESULTS_PER_PAGE_OPTIONS } from '../../constants/admin/tables';
import IconButton from '@material-ui/core/IconButton';
import NavigateBefore from '@material-ui/icons/NavigateBefore';
import NavigateNext from '@material-ui/icons/NavigateNext';
import PopupMenu from '../../components/forms/PopupMenu';

class Pagination extends Component {
    state = { resultsPerPageOpenElement: null, pageOpenElement: null };

    _closeOptions = () => this.setState({ resultsPerPageOpenElement: null, pageOpenElement: null });
    _openresultsPerPageOptions = e => this.setState({ resultsPerPageOpenElement: e.currentTarget });
    _openPageOptions = e => this.setState({ pageOpenElement: e.currentTarget });
    _changePage = pageNumber => this.props.paginationChange(parseInt(pageNumber, 10), this.props.resultsPerPage);
    _changeResultsPerPage = perPage => this.props.paginationChange(1, parseInt(perPage, 10));
    _nextPage = () => this._changePage(this.props.currentPage + 1, this.props.resultsPerPage);
    _previousPage = () => this._changePage(this.props.currentPage - 1, this.props.resultsPerPage);
    render() {
        const prevInactive = this.props.currentPage === 1;
        const nextInactive = this.props.currentPage === this.props.totalPages;
        return (
            <div className="ckp-pagination">
                <div className="ckp-pagination-content">
                    <PopupMenu
                        options={RESULTS_PER_PAGE_OPTIONS}
                        onClose={this._closeOptions}
                        anchorElement={this.state.resultsPerPageOpenElement}
                        onOptionSelected={this._changeResultsPerPage}
                        selected={this.props.resultsPerPage}
                    />
                    <PopupMenu
                        options={range(1, this.props.totalPages + 1)}
                        onClose={this._closeOptions}
                        anchorElement={this.state.pageOpenElement}
                        onOptionSelected={this._changePage}
                        selected={this.props.currentPage}
                    />
                    <span onClick={this._openresultsPerPageOptions} className="ckp-pagination-clickable u-underline">
                        {this.props.resultsPerPage}
                    </span>
                    results/page - Page
                    <span className="ckp-pagination-clickable u-underline" onClick={this._openPageOptions}>
                        {this.props.currentPage}
                    </span>
                    <span className="ckp-pagination-content-end">of {this.props.totalPages}</span>
                    <IconButton onClick={this._previousPage} disabled={prevInactive} color="secondary" component="span">
                        <NavigateBefore />
                    </IconButton>
                    <IconButton onClick={this._nextPage} disabled={nextInactive} color="secondary" component="span">
                        <NavigateNext />
                    </IconButton>
                </div>
            </div>
        );
    }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/tables/Pagination.js